var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "coolicon",
    d: "M7.60022 20.9988H17.0991C17.6082 21.0183 18.1017 20.8034 18.4619 20.4053C18.8221 20.0072 19.0166 19.4617 18.9989 18.899V8.40025C19.0166 7.83759 18.8221 7.29207 18.4619 6.89398C18.1017 6.49588 17.6082 6.28094 17.0991 6.30049H13.2996V2.10098C13.3172 1.53833 13.1228 0.992809 12.7626 0.59471C12.4024 0.196612 11.9088 -0.018326 11.3998 0.0012265H1.90089C1.39182 -0.018326 0.898256 0.196612 0.538073 0.59471C0.177889 0.992809 -0.0165787 1.53833 0.00111198 2.10098V12.5998C-0.0162945 13.1623 0.178267 13.7077 0.538385 14.1057C0.898506 14.5037 1.3919 14.7187 1.90089 14.6995H5.70044V18.899C5.68304 19.4616 5.8776 20.0069 6.23772 20.4049C6.59784 20.803 7.09123 21.018 7.60022 20.9988ZM17.0991 8.40025V18.899H7.60022V14.6995H11.3998C11.9088 14.7187 12.4022 14.5037 12.7623 14.1057C13.1224 13.7077 13.317 13.1623 13.2996 12.5998V8.40025H17.0991ZM11.3998 2.10098V12.5998H1.90089V2.10098H11.3998Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyButton);
export default __webpack_public_path__ + "static/media/copy-button.167f46ff.svg";
export { ForwardRef as ReactComponent };